<template>
  <v-col cols="12">
    <template v-if="!loading">
      <h1>Temperature</h1>
      <highcharts
        :constructor-type="'stockChart'"
        :options="tempChart"
      ></highcharts>
      <h1>Humidité</h1>
      <highcharts
        :constructor-type="'stockChart'"
        :options="rhChart"
      ></highcharts>
      <h1>Pluie</h1>
      <highcharts
        :constructor-type="'stockChart'"
        :options="rainChart"
      ></highcharts>
      <h1>Rafales</h1>
      <highcharts
        :constructor-type="'stockChart'"
        :options="gustChart"
      ></highcharts>
      <h1>Vents moyens</h1>
      <highcharts
        :constructor-type="'stockChart'"
        :options="windChart"
      ></highcharts>
    </template>
    <template v-else>
      <v-skeleton-loader type="card" />
    </template>
  </v-col>
</template>

<script>
import axios from 'axios';
import Highcharts from 'highcharts';
import api from '@/api';
import moment from 'moment';

export default {
  computed: {
    tempChart() {
      const series = [];

        this.data.forEach((element) => {
          const datas = element.data;

          const temps = [];

          datas.forEach((data) => {
            const temp = [
              (moment.utc(data.date).unix() + moment(data.date).utcOffset() / 60 * 3600) * 1000,
              Math.round(parseFloat(data.tmin) * 100) / 100
              || Math.round(parseFloat(data.t) * 100) / 100,
            ];

            temps.push(temp);
          });

          series.push({
            type: 'line',
            dashStyle: element.model == 'obs' ? null : 'dash',
            name: element.model,
            data: temps,
          });
        });

      return {
        series,
        ...this.options,
        xAxis: this.xAxis,
        plotOptions: this.plotOptions,
      };
    },
    rhChart() {
      const series = [];
      Object.entries(this.data).forEach((element) => {
       const datas = element[1].data;
        let rhs = [];
        if(datas.length)
        {
          datas.forEach((data) => {
            rhs.push([
              (moment.utc(data.date).unix() + moment(data.date).utcOffset() / 60 * 3600) * 1000,
              Math.round(parseFloat(data.rhmin) * 100) / 100 ||
                Math.round(parseFloat(data.u) * 100) / 100,
            ]);
          });
          series.push({
            type: "line",
            dashStyle: element[1].model == 'obs' ? null : 'dash',
            name: element[1].model ,
            data: rhs,
          });
        }
      });

      return {
        series,
        ...this.options,
        xAxis: this.xAxis,
        plotOptions: this.plotOptions,
      };
    },
    rainChart() {
      const series = [];
      Object.entries(this.data).forEach((element) => {
        const datas = element[1].data;
        const rains = [];
        if(datas.length)
        {
        datas.forEach((data) => {
          rains.push([
            (moment.utc(data.date).unix() + moment(data.date).utcOffset() / 60 * 3600) * 1000,
            Math.round(parseFloat(data.apcpsfc) * 100) / 100 ||
              Math.round(parseFloat(data.rr1) * 100) / 100,
          ]);
        });
        series.push({
          type: 'column',
          name: element[1].model,
          data: rains,
        });
        }
      });

      return {
        series,
        ...this.options,
        xAxis: this.xAxis,
        plotOptions: this.plotOptions,
      };
    },
    gustChart() {
      const series = [];
      Object.entries(this.data).forEach((element) => {
        const datas = element[1].data;
        const gusts = [];

        if(datas.length)
        {
        datas.forEach((data) => {
          gusts.push([
            (moment.utc(data.date).unix() + moment(data.date).utcOffset() / 60 * 3600) * 1000,
            Math.round(parseFloat(data.gustsfc * 3.6) * 100) / 100 ||
              Math.round(parseFloat(data.rafper * 3.6) * 100) / 100,
          ]);
        });
        series.push({
          type: 'line',
          dashStyle:element[1].model == 'obs' ? null : 'dash',
          name: element[1].model,
          data: gusts,
        });
        }
      });

      return {
        series,
        ...this.options,
        xAxis: this.xAxis,
        plotOptions: this.plotOptions,
      };
    },
    windChart() {
      const series = [];
      Object.entries(this.data).forEach((element) => {
        const datas = element[1].data;
        const winds = [];

        if(datas.length)
        {
        datas.forEach((data) => {
          winds.push([
            (moment.utc(data.date).unix() + moment(data.date).utcOffset() / 60 * 3600) * 1000,
            Math.round(parseFloat(data.wind_speed * 3.6) * 100) / 100 ||
              Math.round(parseFloat(data.ff * 3.6) * 100) / 100,
          ]);
        });
        series.push({
          type: 'line',
          dashStyle: element[1].model == 'obs' ? null : 'dash',
          name: element[1].model,
          data: winds,
        });
        }
      });

      return {
        series,
        ...this.options,
        xAxis: this.xAxis,
        plotOptions: this.plotOptions,
      };
    },
  },
  data() {
    return {
      data: [],
      data_rmse: {},
      loading: true,
      idsynop: null,
      options: {
        legend: { enabled: true },
        rangeSelector: {
          enabled: false,
        },
      },
      plotOptions: {
        series: {
          marker: { enabled: true },
          dataGrouping: {
            enabled: false,
          },
        },
      },
      xAxis: {
        crosshair: true,
        events: {
          setExtremes: this.syncExtremes,
        },
        ordinal: false,
      },
    };
  },
  methods: {
    displayRmse(param) {
      if (
        this.data_rmse[`RMSE_${param}_AROME`] != undefined &&
        this.data_rmse[`RMSE_${param}_ARPEGE`] != undefined &&
        this.data_rmse[`RMSE_${param}_WRFDA`] != undefined &&
        this.data_rmse[`RMSE_${param}_WRFDK`] != undefined &&
        this.data_rmse[`RMSE_${param}_GFS`] != undefined &&
        this.data_rmse[`RMSE_${param}_ARW`] != undefined
      ) {
        return {
          arome: this.data_rmse[`RMSE_${param}_AROME`],
          arpege: this.data_rmse[`RMSE_${param}_ARPEGE`],
          wrfda: this.data_rmse[`RMSE_${param}_WRFDA`],
          wrfdk: this.data_rmse[`RMSE_${param}_WRFDK`],
          gfs: this.data_rmse[`RMSE_${param}_GFS`],
          arw: this.data_rmse[`RMSE_${param}_ARW`],
        };
      }
    },
    syncExtremes(e) {
      var thisChart = this.chart;

      if (e.trigger !== 'syncExtremes') {
        // Prevent feedback loop
        Highcharts.each(Highcharts.charts, (chart) => {
          if (chart !== thisChart) {
            if (chart.xAxis[0].setExtremes) {
              // It is null while updating
              chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {
                trigger: 'syncExtremes',
              });
            }
          }
        });
      }
    },
    async getData() {
      this.loading = true;

      try {
        const models = await api.forecast.getMulti(this.$route.params.geoname);

        this.data = models.map((model) => {
          // Keep only data whith minimum pas when many exists for the same date
          const timestamp = model.data.filter(data => data.pas === '1').pop()?.timestamp;

          return {
            ...model,
            data: model.data.filter((data) => data.pas === '1' || timestamp === undefined || data.timestamp > timestamp)
          };
        });
      } catch (error) {
        console.error(error);
      }

      this.loading = false;
    },
    async getRmse() {
      try {
        const { data } = axios.get(`/synop/${this.idsynop}/rmse`);
        this.data_rmse = data;
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.idsynop = this.$route.params.idsynop;
    this.getData();
  },
};
</script>

<style>
</style>
